import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { PersonModel } from '@bayclubs/court-booking-employee-api';

@Component({
    selector: 'app-player-list-item',
    templateUrl: './player-list-item.component.html',
    styleUrls: ['./player-list-item.component.scss'],
    standalone: false
})
export class PlayerListItemComponent implements OnInit {
    @Input() player: PersonModel;
    @Input() selectedPlayer: PersonModel;
    @Output() playerSelected: EventEmitter<PersonModel> = new EventEmitter();

    constructor() { }

    ngOnInit(): void { }

    get isPlayerSelected(): boolean {
        return this.selectedPlayer && this.player.personId === this.selectedPlayer.personId;
    }

    onPlayerSelected() {
        this.playerSelected.emit(this.player);
    }
}
